import { Injectable } from '@angular/core';
import { ConfigResourceTypesConstraint } from '../models/config.resources.model';
import { PGUtilities } from '../utilities/pg-utilities';

@Injectable({
    providedIn: 'root'
})
export class ValidationService {
    constructor() {}

    validateFieldValueFormat(fieldFormat:String, fieldValue:any) {
        if(fieldValue == null || fieldValue == '') return true;
        else {
            switch(fieldFormat) {
                case 'recipient': {
                    let _cVia = fieldValue.split('/')[0]
                    if(_cVia == 'email') return PGUtilities.emailRegExp.test(fieldValue.replace(/^[^\/]*\//, ''));
                    else if(_cVia == 'phone') return PGUtilities.phoneRegExp.test(fieldValue.replace(/^[^\/]*\//, ''));
                    else return false;
                }
                case 'email': return PGUtilities.emailRegExp.test(fieldValue);
                case 'phone': return PGUtilities.phoneRegExp.test(fieldValue);
                case 'integer': return /^-?\d+$/.test(fieldValue);
                case 'decimal':
                case 'float': return /^-?\d+.?\d*$/.test(fieldValue);
                case 'tickets-experience':
                case 'tickets-host':
                    try {
                        let _cObj = JSON.parse(fieldValue);
                        if(_cObj.fullPrice == null || typeof _cObj.fullPrice == 'number') return true;
                    } catch(ex) {}
                    return false;
                case 'embed':
                    try {
                        let _cObj = JSON.parse(fieldValue);
                        if(!(_cObj instanceof Array)) {
                            _cObj = [_cObj]
                        }

                        for(let _item of _cObj) {
                            if(_item.src) {
                                if(!_item.ratio) {
                                    return false
                                }
                                else if(_item.ratio == 'specify') {
                                    if(!_item.width || !_item.height) {
                                        return false
                                    }
                                }
                            }
                        }

                        return true
                    } catch(ex) {}
                    return false;

                default: return true;
            }
        }
    }

    validateFieldValueProperty(fieldProperty:string, propertyValue:any, fieldValue:any) {
        if(propertyValue == null) return true;
        else {
            switch(fieldProperty) {
                case 'required': {
                    if(propertyValue && (fieldValue == null || fieldValue === '')) return false;
                    else return true;
                }
                case 'maxLength': {
                    if(fieldValue != null && fieldValue.length > propertyValue) return false;
                    else return true;
                }
                case 'min': {
                    if(propertyValue != null && fieldValue != null && fieldValue < propertyValue) return false;
                    else return true;
                }
                case 'max': {
                    if(propertyValue != null && fieldValue != null && fieldValue > propertyValue) return false;
                    else return true;
                }
                default: return true;
            }
        }
    }

    validateFieldValueConstraints(fieldValue:any, fieldConstraints:Array<ConfigResourceTypesConstraint>, targetValues:{ [id:string]: any }):Array<any> {
        let _cIssues = [];

        for(let i = 0; i < fieldConstraints.length; i++) {
            let _cConstraint = fieldConstraints[i];
            let _cTargetValue = targetValues[_cConstraint.field];

            switch(_cConstraint.operator) {
                case '==': {
                    if(fieldValue != _cTargetValue) _cIssues.push(_cConstraint);
                } break;
                case '!=': {
                    if(fieldValue == _cTargetValue) _cIssues.push(_cConstraint);
                } break;
                case '<': {
                    if(fieldValue >= _cTargetValue) _cIssues.push(_cConstraint);
                } break;
                case '<=': {
                    if(fieldValue > _cTargetValue) _cIssues.push(_cConstraint);
                } break;
                case '>': {
                    if(fieldValue <= _cTargetValue) _cIssues.push(_cConstraint);
                } break;
                case '>=': {
                    if(fieldValue < _cTargetValue) _cIssues.push(_cConstraint);
                } break;
            }
        }

        return _cIssues;
    }
}
